import React from "react";
import "./GridTitle.css";
const GridTitle = props => { return<div className={"title " + props.className}>{props.children}</div>};

export default GridTitle;